/**
 * Centralização de caminhos (URLs) do sistema.
 *
 * ROOT: Usado em definições de <Route path={...} />
 * LINKS: Usado em <Link to={...} />, href, ou navigate(...)
 */
export const PATHS = {
  LESSON_PLAN: {
    ROOT: '/plano-de-aulas/:selectedTab',
    START: '/plano-de-aulas/inicio',
    FAVORITES: '/plano-de-aulas/favoritos',
    TAB: slug => `/plano-de-aulas/${slug}`
  },
  REPORTS: {
    SEDUC_PI: '/relatorio/seduc-pi',
    SEDUC_PI_GERAL: '/relatorio/seduc-pi/geral',
    SEDUC_PI_GRE: (greId, questionBookId) => `/relatorio/seduc-pi/geral/gre/${greId}${questionBookId ? `/${questionBookId}` : ''}`,
    SEDUC_PI_GRE_ROOT: '/relatorio/seduc-pi/geral/gre/:greId',
    SEDUC_PI_GRE_QB_ROOT: '/relatorio/seduc-pi/geral/gre/:greId/:questionBookId',

    LIVE_CLASSES: '/relatorio/aula-ao-vivo',
    RECORD_CLASSES: '/relatorio/aulas-gravadas',
    REGISTRATION: '/relatorio/cadastro',
    ACCESS: '/relatorio/acesso',
    COURSE_PROGRESS: '/relatorio/progresso-de-curso',
    QUESTIONS: '/relatorio/relatorio-de-perguntas',
    QUIZ: '/relatorio/quiz',
    LIVE_ACCESS: '/relatorio/acessos-aulas-ao-vivo',
    ENEM: '/relatorio/enem',
    ACCESS_FUNNEL: '/relatorio/funil-de-acessos',
    ADHERENCE: '/relatorio/adesao',
    ESSAY: '/relatorio/redacao',
    ESSAY_STUDENT: id => `/relatorio/redacao/aluno/${id}`,
    ESSAY_STUDENT_ROOT: '/relatorio/redacao/aluno/:studentId',
    LEVELING_TEST: '/relatorio/teste-de-nivelamento',
    UPTIME_MONTHLY: '/relatorio/disponibilidade',
    PLATFORM_USAGE: '/relatorio/uso-da-plataforma'
  }
};
